import { render, staticRenderFns } from "./ResumoComercial.vue?vue&type=template&id=dd4292e4&scoped=true"
import script from "./ResumoComercial.vue?vue&type=script&lang=js"
export * from "./ResumoComercial.vue?vue&type=script&lang=js"
import style0 from "./ResumoComercial.vue?vue&type=style&index=0&id=dd4292e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4292e4",
  null
  
)

export default component.exports